export default "__VITE_ASSET__BM$KU81K__"